"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateWorkspaceClient = void 0;
var firestore_1 = require("firebase/firestore");
var getWorkspaceRefClient_1 = require("../get/getWorkspaceRefClient");
var updateWorkspaceClient = function (_a) {
    var firestore = _a.firestore, workspaceId = _a.workspaceId, workspace = _a.workspace;
    var workspaceRef = (0, getWorkspaceRefClient_1.getWorkspaceRefClient)({ firestore: firestore, workspaceId: workspaceId });
    return (0, firestore_1.updateDoc)(workspaceRef, workspace);
};
exports.updateWorkspaceClient = updateWorkspaceClient;
